/* One delegated listener, including editor-added/replaced section instances. */
(function () {
  'use strict';
  if (window.ogLightingPage) { window.ogLightingPage.syncAnchors(); return; }
  function syncAnchors() {
    var used = new Set();
    document.querySelectorAll('[data-og-region]').forEach(function (region) {
      if (!region.dataset.ogInstance) region.dataset.ogInstance = region.id;
      region.id = region.dataset.ogInstance;
    });
    document.querySelectorAll('[data-og-region]').forEach(function (region) {
      var requested = (region.dataset.ogAnchor || '').trim();
      if (!requested || used.has(requested)) return;
      var other = document.getElementById(requested);
      if (!other || other === region) { region.id = requested; used.add(requested); }
    });
  }
  function updateChoice(button) {
    var card = button.closest('[data-og-picker]');
    if (!card || !card.closest('[data-og-region]')) return;
    card.querySelectorAll('[data-og-choice]').forEach(function (chip) {
      chip.setAttribute('aria-pressed', chip === button ? 'true' : 'false');
    });
    var price = card.querySelector('[data-og-price]');
    var size = card.querySelector('[data-og-size]');
    var link = card.querySelector('[data-og-link]');
    if (price) price.textContent = button.dataset.price || '';
    if (size) size.textContent = [button.dataset.label, size.dataset.suffix].filter(Boolean).join(' ');
    if (link) link.setAttribute('href', button.dataset.url || '#');
  }
  window.ogLightingPage = {syncAnchors: syncAnchors, updateChoice: updateChoice};
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var button = event.target.closest('[data-og-choice]');
    if (button) updateChoice(button);
  });
  document.addEventListener('shopify:section:load', syncAnchors);
  document.addEventListener('shopify:section:unload', function () { setTimeout(syncAnchors, 0); });
  document.addEventListener('shopify:section:reorder', syncAnchors);
  function ready() {
    syncAnchors();
    if (location.hash.length > 1) {
      var target;
      try { target = document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch (error) { return; }
      if (target && target.matches('[data-og-region]')) target.scrollIntoView();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once: true});
  else ready();
})();
